<template>
  <modal
    name="payment-link"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="650"
    height="auto"
    @closed="closeModal()"
    @before-open="getData"
  >
    <div class="modalWrapper">
      <div class="content__box">
        <div class="content__box__header">
          <p class="text-white txt--ss opacity--50">Collect Payment</p>
        </div>
        <div class="content__divider"></div>
        <div class="content__box__body">
          <div class="form-group modified-toggle-switch">
            <div class="form-group mt-3" style="height: 70px;">
              <InputClipboard placeholder="Link for payment" v-model="link" v-if="link"/>
              <div class="create-payment-link cursor-pointer" v-else @click="generateLink" :class="{disabled: !allowClick}">
                <p>Create payment link</p>
              </div>
              <label class="remove-link cursor-pointer" @click="removeLink" v-if="link">Expire Link</label>
            </div>
          </div>
        </div>
      </div>
      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </modal>
</template>
<script>
import InputClipboard from "@/components/InputClipboard";
export default {
  name: "PaymentLink",
  components: {
    InputClipboard,
  },
  data() {
    return {
      allowClick: false,
      link: "",
      booking_id: "",
      include_other_pending: true, // TODO: add UI to allow this to be changed
    };
  },

  methods: {
    getData(e){
      this.booking_id = e.params.booking_id;
      this.axios.post(window.hostname + "api/auth/get-checkout-session", {
        booking_id: this.booking_id,
      }).then((res) => {
        if (res.data.status && res.data.url) {
          this.link = res.data.url;
        }
        this.allowClick = true;
      }).catch((error) => {
        console.error(error);
        
        this.$toasted.show("Unexpected error!", {
          icon: 'times-circle',
          className: 'error-class'
        });
      });
    },
    closeModal() {
      this.reset();
      this.$modal.hide("payment-link");
    },
    generateLink() {
      if (this.allowClick) {
        this.axios.post(window.hostname + "api/auth/create-checkout-session", {
          booking_id: this.booking_id,
          include_other_pending: this.include_other_pending,
        }).then((res) => {
          if (res.data.status) {
            this.link = res.data.url;
          }
        }).catch((error) => {
          console.error(error);
          
          this.$toasted.show("Unexpected error!", {
            icon: 'times-circle',
            className: 'error-class'
          });
        });
      }
    },
    removeLink() {
      this.axios.post(window.hostname + "api/auth/expire-checkout-session", {
        booking_id: this.booking_id,
      }).then((res) => {
        if (res.data.status) {
          this.reset();
        }
      }).catch((error) => {
        console.error(error);
        
        this.$toasted.show("Unexpected error!", {
          icon: 'times-circle',
          className: 'error-class'
        });
      });
    },
    reset() {
      this.link = "";
    },
  },
};
</script>

<style scoped>
  .create-payment-link {
    background-color: #f5a621;
    color: white;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    margin-top: 18px;
  }
  .remove-link {
    font-size: 10px;
    color: #ef5355;
  }
  label {
    margin: 0 10px;
  }

  .disabled {
    background-color: grey;
    cursor: default;
  }
</style>